var SCM = SCM || {};

SCM.NavDropdown = (function () {
    const mobile_width_breakpoint = 930;

    return {
        registerNavDropdownEvents: registerNavDropdownEvents
    };

    function registerNavDropdownEvents() {
        var isDropdownOpen = false;
        var $currMenu = null;
        var $currLink = null;

        $('.js-nav-dropdown, .mobile-nav-arrow').on('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            SCM.Toolbar.closeHypothesis();
            var $this = $(this);
            $currMenu = $this.siblings('.site-menu');
            $currLink = $this;

            if ($(window).width() > mobile_width_breakpoint) {
                $('.site-menu-item .site-menu').not($currMenu).css('display', 'none');
                $('.js-nav-dropdown').not($currLink).attr('aria-expanded', 'false');
            }
            else {
                toggleMobileDropdownArrow($this);
            }

            $currMenu.slideToggle('fast', function () {
                if ($(this).is(':visible')) {
                    $(this).css('display', 'block');
                    $currLink.attr('aria-expanded', 'true');
                    isDropdownOpen = true;
                }
                else {
                    $currLink.attr('aria-expanded', 'false');
                    isDropdownOpen = false;
                }
            });
        });  

        $(document.body).on('click', function (event) {
            if (isDropdownOpen) {
                isDropdownOpen = closeDropdownOnPageClickOrKeypress(event, $currLink, $currMenu);
            }
        });

        $(document.body).on('keyup', function (event) {
            if (isDropdownOpen) {
                closeDropdownOnEscapeKeyPress(event, $currLink);
                isDropdownOpen = closeDropdownOnPageClickOrKeypress(event, $currLink, $currMenu);
            }
        });
    }

    function toggleMobileDropdownArrow($clickedLink) {
        var $targetArrow = $clickedLink;
        // Determine if $(".mobile-nav-arrow") was clicked directly, or is a sibling of the clicked element - for the purposes of changing the icon
        $targetArrow = $clickedLink.hasClass('mobile-nav-arrow') ? $clickedLink : $clickedLink.siblings('.mobile-nav-arrow');
        $targetArrow.toggleClass('icon-general_arrow-down');
        $targetArrow.toggleClass('icon-general_arrow-up');
    }
   

    function closeDropdownOnPageClickOrKeypress(event, $currLink, $currMenu) {
        // If the target of the click isn't a descendent of the most recently opened menu,
        // and we are not in mobile view
        if ($currMenu.has(event.target).length === 0 && $(window).width() > mobile_width_breakpoint) {
            $($currMenu).css('display', 'none');
            $currLink.attr('aria-expanded', 'false');
            return false;
        }
        return true;
    }

    function closeDropdownOnEscapeKeyPress(event, $currLink) {
        if (event.key == 'Escape' || event.key == 'Esc') {
            $('.site-menu-item .site-menu').css('display', 'none');
            $('.js-nav-dropdown').attr('aria-expanded', 'false');
            $currLink.focus();
        }
    }

})();